import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { RouteConfig } from "../config/router-config.model";

export function getAllParents(route: RouteConfig, routeLookup: Record<string, RouteConfig>): RouteConfig[] {
	const parents: RouteConfig[] = [];
	const parentName: string | undefined = route.parent;

	if (parentName) {
		const parentRoute: RouteConfig | undefined = routeLookup[parentName];
		if (!parentRoute) {
			throw new Error(`Parent '${parentName}' not found for route key '${route.name}'`);
		}
		parents.unshift(...getAllParents(parentRoute, routeLookup), parentRoute);
	}

	return parents;
}

export function getActivatedRouteSnapshot(snapshot: RouterStateSnapshot): ActivatedRouteSnapshot | null {
	let activated = snapshot?.root.firstChild;

	while (activated?.firstChild) {
		activated = activated.firstChild;
	}

	return activated;
}
